module.exports = __webpack_public_path__ + "img/expand_24.d89dad38.svg";